<button mat-button
        [matMenuTriggerFor]="userMenu"
        [attr.aria-label]="'aria.user-context-menu' | translate">

    <app-user-avatar [label]="person?.name"
                     [hideLabel]="true"
                     [imageUrl]="person?.photo ? (person.photo | base64src:'') : null" />
</button>

<mat-menu #userMenu>
    <div class="user-menu">
        <div class="user-menu-header px-5">
            <div class="user-menu-name">
                @if (person?.name) {
                    <span>{{ person.name }} </span>
                }
                @if (person?.surname) {
                    <span>{{ person.surname }}</span>
                }
            </div>
            @if (person?.phone) {
                <div class="user-menu-phone">
                    {{ person.phone | phoneFormat }}
                </div>
            }
        </div>

        <mat-divider class="mt-1"></mat-divider>

        <button mat-menu-item [routerLink]="[routeEntity.Root, routeEntity.Person]">
            <mat-icon fontIcon="settings"></mat-icon>
            <span>{{ 'core.main_menu.person' | translate }}</span>
        </button>

        <button mat-menu-item [routerLink]="[routeEntity.Root, routeEntity.Support]">
            <mat-icon fontIcon="support_agent"></mat-icon>
            <span>{{ 'core.main_menu.support' | translate }}</span>
        </button>

        <button mat-menu-item [routerLink]="[routeEntity.Root, routeEntity.Logout]">
            <mat-icon fontIcon="logout"></mat-icon>
            <span>{{ 'core.main_menu.logout' | translate }}</span>
        </button>

    </div>
</mat-menu>
